<template>
  <div class="text-template">
    <p>{{msg.kejianname}}</p>
    <p>{{msg.xuexidate | times}}</p>
    <!-- <img :src="msg.imgUrl | img" alt=""> -->
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    // console.log(this.msg);
  },
  methods: {},
  props:{
    msg:Object
  }
};
</script>
<style lang='scss' scoped>
.text-template {
  p{
    &:nth-child(1){
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      word-break: break-all;
      grid-row-start: 1;
    }
    &:nth-child(2){
      color: #999999;
      font-size: .24rem;
    }
  }
  img{
    width: 2.4rem;
    height: 2rem;
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 3;
  }
  display: grid;
  grid-gap: .2rem;
  font-size: .3rem;
  background: #fff;
  padding: .2rem;
  margin-bottom: .2rem;
}
</style>